import './index.css'
import React from 'react';
import InputFileUpload from '../common/UploadForm';
import InputFileDownload from '../common/DownloadForm';


export default function Attachment(props: any) {
  const action = props.action
  const handleSelection = props.handleSelection
  const ticketUpdateForm = props.ticketUpdateForm

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Adjunto</p>
        </div>

        <div className='tkt-form-section-item'>
          {(action === 'create') && (
            <InputFileUpload
              name={'attachment'}
              handleSelection={handleSelection}
            />
          )}
          {(action === 'view') && (
            <InputFileDownload
              path={ticketUpdateForm.attachment}
            />
          )}
        </div>
      </div>

    </React.Fragment>
  );
}
